// extracted by mini-css-extract-plugin
module.exports = {"header":"header__3QGkI","buildName":"buildName__3mpxT"};